// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";

import { ValidacaoProprietario } from "../interfaces/ValidacaoProprietario";

export const atualizarUsuarioService = async (
  usuarioId: number | undefined,
  atualizarUsuario: ValidacaoProprietario
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/usuario/${usuarioId}`;
    try {
      const response = await axios.put(URL, atualizarUsuario, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }

      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }
};
